var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card-text',[_c('v-row',_vm._l((_vm.docs),function(doc){return _c('v-col',{key:doc.id,attrs:{"cols":"12","sm":"6","md":"4","lg":"3"}},[_c('DeviceItem',{attrs:{"doc":doc}})],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }